import type { FaireProductEntity } from "../../entity_types/product";

export const p_3tsy467maz: FaireProductEntity = {
  token: "p_3tsy467maz",
  type: "product",
  name: "Boundary Waters",
  brandName: "Lakehouse Candle Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/a6c1f45a8df87209382f8cf35fdba2dd46dc5562a489b2018cc3d8fceee28c4a.jpeg",
  priceDollars: 15.5,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/6309ef848a02ab81a26eaa67f0fc5ab5cff7d80817e5182a4b1aef57f5096e22.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
